import styled from '@emotion/styled';

export const HistoryWrapper = styled.div`
  width: 100%;
`;
